<template>
    <div class="save-buttons">
        <al-button
            :disabled="!changed.length"
            type="submit"
            variant="primary"
            @click="$emit('onSave', { changed })"
        >
            <al-icon icon="save" /> Save Configuration
        </al-button>
        <al-button
            type="reset"
            :disabled="!changed.length"
            @click="$emit('onReset')"
        >
            <al-icon icon="close" /> Reset Changes
        </al-button>
        <span
            v-if="changed.length"
            class="unsaved-warning"
        > You have unsaved changes </span>
    </div>
</template>

<script setup lang="ts">
import { WorkstreamDefinitionOperationConfigGridRow } from '@/pages/OperationsAdministration/types/WorkstreamDefinitionOperationConfigGridRow';

interface Props {
    changed: WorkstreamDefinitionOperationConfigGridRow[];
}

const _props = defineProps<Props>();
defineEmits([ 'onSave', 'onReset' ]);
</script>

<style scoped lang="scss">
@use '@/styles/commonPageStyles.scss';

.save-buttons {
    display: flex;
    padding-top: 1rem;
    gap: 1rem;
    align-items: center;

    .unsaved-warning {
        color: #e39a45;
    }

    al-button {
        al-icon {
            // icon centre doesn't match text centre
            font-size: 1.3rem;
            margin: 0 0.3rem;
        }
    }
}
</style>
